import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  NextPageService,
  NavigationLocation,
  PageLayout,
  SearchType,
  SliderType,
} from "@cvx/nextpage";
import { Subscription } from "rxjs";
import { environment } from '../environments/environment';
import { ComponentEventService } from "../services/component_event.service";
import { Utility } from "../services/utility";

@Component({
    selector: "app-root",
    templateUrl: "app.component.html",
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  NavigationLocation = NavigationLocation;
  PageLayout = PageLayout;
  SearchType = SearchType;
  SliderType = SliderType;
  subscriptions: Subscription[] = [];
  isProd!: boolean;
  hideHeaderFooter: boolean = false;

  constructor(private NP: NextPageService,
              private compEventService: ComponentEventService
  ) {
    this.NP.options.sitename = "Fitness-For-Service Level 1";
  }

  ngOnInit() {
    // Set a default unit system if it's not already set
    if (!localStorage.getItem("unitType")) {
      localStorage.setItem("unitType", "0"); // Default to US
    }
    this.isProd = environment.production;
    this.setHeaderFooterSubscription();
    this.unitSelectedSubscription();
  }

  setEnvironmentName(): string {
    return environment.envName;
  }

  private async setHeaderFooterSubscription() {
    this.subscriptions.push(this.compEventService.hideHeaderFooter$.subscribe({
      next: (value: boolean) => {
        this.hideHeaderFooter = value ?? false;
      }, error: (err: any) => {
        console.log(err);
        this.hideHeaderFooter = false;
      }
    }));
  }

  private unitSelectedSubscription(): void {
    this.compEventService.unitSelected$.subscribe({
      next: (value: number) => {
        let navs = [...this.NP.options.navigationItems];
        if (navs?.length) {
          let unitNavIndx = navs.findIndex(x => x.title.includes('Units'));
          if (unitNavIndx >= 0) {
            let unitNav = navs[unitNavIndx];
            unitNav.title = "Units " + Utility.getActualUnitName();
            navs.splice(unitNavIndx, 1, unitNav);
            this.NP.options.navigationItems = [...navs];
          }
        }
      }
    });
  }

  ngOnDestroy(): void {
    for (let sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }
}
